import {formatUrl} from 'url-lib';

import {fetchJSON} from 'js-utils/http';
import {keysCamelToSnake} from 'js-utils/transformation';

import {SEARCH_AUTOCOMPLETE_SUGGESTIONS_URL} from '../../constants/constants';


export const searchAutocompleteSuggestions = ({placeId, onlineEventsOnly, query}) => {
    let queryParams = {
        placeId,
        q: query,
        completionTypes: ['event', 'query'],
        'expand.destination_event': [
            'primary_venue',
            'image',
        ],
    };

    if (onlineEventsOnly) {
        queryParams.onlineEventsOnly = true;
    }

    queryParams = keysCamelToSnake(queryParams);
    return fetchJSON(formatUrl(SEARCH_AUTOCOMPLETE_SUGGESTIONS_URL, queryParams));
};
